import { createEvent, restore, createStore, createEffect } from "effector";
import { IRoute, IRoutePoint } from "./routes";
import { CoordinateDecPoints } from "../../../common/config/vars";
import IconAreaIndiv from "../../../common/assets/icons/areaIndividual.png";
import IconAreaTotal from "../../../common/assets/icons/areaTotal.png";
import IconAreaBag from "../../../common/assets/icons/areaBag.png";
import IconCar from "../../../common/assets/icons/car.png";
import IconMovingArrow from "../../../common/assets/icons/movingArrow.png";
import { getUuidAndSession } from "../../../common/localStorage";
import { IAccountPoint } from "../../../common/accounts2";

export interface ICollectionPoint {
  address: string;
  id: string;
  lastCollectingDate: string;
  pointLatitude: number;
  pointLongitude: number;
  pointStatus: string;
  pointType: string;
  routeId: any;
  idxInOldArr?: number;
  idxRoute?: number;
  idxInRoute?: number;
}

//

export interface IClickedPoint {
  pointId: string;
  routeIdx: number;
  pointIdx: number;
  idxInRoute: number;
}

export const changeClickedPoint = createEvent<IClickedPoint | null>();

export const $clickedPoint = restore<IClickedPoint | null>(
  changeClickedPoint,
  null
);

export const queryGarbageCollectionPoints = createEffect<
  number[],
  ICollectionPoint[]
>();

export const $garColPoints = createStore<ICollectionPoint[]>([]);

$garColPoints.on(queryGarbageCollectionPoints.doneData, (_, val) => val);

export interface IQueryGarbageCollectionPoints {
  lat: number;
  lng: number;
  rad: number;
}

queryGarbageCollectionPoints.use((center: number[]) =>
  fetch("https://izba.kras-abs.ru/api/v2/getGarbageCollectionPoints", { //только крк
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      userLat: Math.floor(center[0] * CoordinateDecPoints) + "", //"560365",
      userLon: Math.floor(center[1] * CoordinateDecPoints) + "", //"929168",
      radius: "8",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => res.json())
    .then((res) => {
      console.log("POINTS:", res);
      console.log("Lat:", Math.floor(center[0] * CoordinateDecPoints));
      console.log("Lng:", Math.floor(center[1] * CoordinateDecPoints));
      let points = res.table as ICollectionPoint[];
      return points;
    })
);

//проверяем, содержаться ли точки из points в маршрутах routes, и вохвращаем отфильтрованные данные
export const getPoints4map = (points: ICollectionPoint[], routes: IRoute[]) => {
  let newPoints = [] as ICollectionPoint[];
  for (let pi = 0, plen = points.length; pi < plen; pi++) {
    for (let ri = 0, rlen = routes.length; ri < rlen; ri++) {
      let rpoints = routes[ri].garbageCollectionPoints;
      for (let rpi = 0, rplen = rpoints.length; rpi < rplen; rpi++) {
        if (points[pi].id === rpoints[rpi].pointId) {
          if (rpoints[rpi].isDoneByMonitoring || rpoints[rpi].isDone)
            points[pi].pointStatus = "Собрано";
          else if (rpoints[rpi].isDoneByMonitoring || rpoints[rpi].isCanceled)
            points[pi].pointStatus = "Закрыто";
          // points[pi].pointStatus
          points[pi].idxInOldArr = pi;
          points[pi].idxRoute = ri;
          points[pi].idxInRoute = rpi;
          newPoints.push(points[pi]);
        }
      }
    }
  }
  return newPoints;
};

export const getAccountPointData4map = (point: IAccountPoint, routes: IRoute[]) => {
  //@ts-ignore
  let newPoint: ICollectionPoint = {...point};
  routes.forEach((r, ri) => {
    r.garbageCollectionPoints.forEach((rpitem, rpi) => {
      if(rpitem.pointId == point.id) {
        if (rpitem.isDoneByMonitoring || rpitem.isDone) newPoint.pointStatus = "Собрано";
        else if (rpitem.isDoneByMonitoring || rpitem.isCanceled) newPoint.pointStatus = "Закрыто";
        //newPoint.idxInOldArr = pi;
        newPoint.idxRoute = ri;
        newPoint.idxInRoute = rpi;
        return [newPoint];
      }
    })
  })
  return [];
}; 

export const getStatusIconName = (status: string) => {
  let iconName: string = "islands#blackCircleDotIcon";
  switch (status) {
    case "Собрано":
      iconName = "islands#greenCircleDotIcon";
      break;
    case "Закрыто":
      iconName = "islands#orangeCircleDotIcon";
      break;
  }
  return iconName;
};

//получаем расстояние между двумя точками на карте (в километрах)
export const getDistanceBetween2pointsInKm = (bounds: number[][]) => {
  let lat1 = bounds[0][0],
    lng1 = bounds[0][1];
  let lat2 = bounds[1][0],
    lng2 = bounds[1][1];
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLng = deg2rad(lng2 - lng1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

//получаем расстояние между двумя точками на карте (в метрах)
export const getDistanceBetween2pointsInM = (bounds: number[][]) => {
  return getDistanceBetween2pointsInKm(bounds) * 1000;
};

export const getRadiusCoeff = (zoom: number) => {
  return Math.round((zoom * 6) / 16);
};

export const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

export const getPointTypeIconUrl = (type: string) => {
  console.log("img:", type.split(" ")[0], type);
  switch (type.split(" ")[0]) {
    case "Общая":
      return IconAreaTotal;
    case "Индивидуальная":
      return IconAreaIndiv;
    case "Мешковая":
      return IconAreaBag;
  }
  return null;
};

export const removeCityFromAddr = (addr: string) => {
  let arr = addr.split("г,");
  if (arr.length === 1) return arr[0];
  return arr[1].trim();
};

export const getCarIcon = () => IconCar;
export const getIconMovingArrow = () => IconMovingArrow;
